export default "__VITE_ASSET__0014df78__"